import React from 'react';
import classNames from 'classnames';
import { SectionProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';
import Tabs, { TabList, Tab, TabPanel } from './../elements/Tabs';
import Image from '../elements/Image';

const propTypes = {
  ...SectionProps.types
}

const defaultProps = {
  ...SectionProps.defaults
}

class FeaturesTabs extends React.Component {

  render() {

    const {
      className,
      topOuterDivider,
      bottomOuterDivider,      
      topDivider,
      bottomDivider,
      hasBgColor,
      invertColor,
      pushLeft,
      ...props
    } = this.props;

    const outerClasses = classNames(
      'features-tabs section center-content',
      topOuterDivider && 'has-top-divider',
      bottomOuterDivider && 'has-bottom-divider',
      hasBgColor && 'has-bg-color',
      invertColor && 'invert-color',
      className
    );

    const innerClasses = classNames(
      'features-tabs-inner section-inner',
      topDivider && 'has-top-divider',
      bottomDivider && 'has-bottom-divider'
    );

    const sectionHeader = {
      title: 'Built Exclusively for Your Business',
      paragraph: 'TRICORE delivers powerful software solutions designed to transform how you work. From custom web development to enterprise integration, we create tailored solutions that perfectly match your unique business needs.'
    };

    return (
      <section
        {...props}
        id="solutions"
        className={outerClasses}
      >
        <div className="container">
          <div className={innerClasses}>
            <SectionHeader data={sectionHeader} className="center-content" />
            <Tabs active="tab-a">
              <TabList>
                <Tab tabId="tab-a">
                  <div className="features-tabs-tab-image mb-12">
                    <Image
                      src={require('./../../assets/images/features-tabs-icon-01.svg')}
                      alt="Tab icon 01"
                      width={56}
                      height={56} />
                  </div>
                  <div className="text-color-high fw-600 text-sm">
                    Custom Development
                  </div>
                </Tab>
                <Tab tabId="tab-b">
                  <div className="features-tabs-tab-image mb-12">
                    <Image
                      src={require('./../../assets/images/features-tabs-icon-02.svg')}
                      alt="Tab icon 02"
                      width={56}
                      height={56} />
                  </div>
                  <div className="text-color-high fw-600 text-sm">
                    System Integration
                  </div>                  
                </Tab>
                <Tab tabId="tab-c">
                  <div className="features-tabs-tab-image mb-12">
                    <Image
                      src={require('./../../assets/images/features-tabs-icon-03.svg')}
                      alt="Tab icon 03"
                      width={56}
                      height={56} />
                  </div>
                  <div className="text-color-high fw-600 text-sm">
                    Data Analytics
                  </div>                  
                </Tab>
                <Tab tabId="tab-d">
                  <div className="features-tabs-tab-image mb-12">
                    <Image
                      src={require('./../../assets/images/features-tabs-icon-04.svg')}
                      alt="Tab icon 04"
                      width={56}
                      height={56} />
                  </div>
                  <div className="text-color-high fw-600 text-sm">
                    Cloud Services
                  </div>
                </Tab>                
              </TabList>
              <TabPanel id="tab-a">
                <div className="features-tabs-panel-content">
                  <div className="features-tabs-panel-text mb-32">
                    <h3 className="mt-0 mb-16">Custom Web Solutions</h3>
                    <p className="mb-24">
                      We specialize in creating bespoke web applications and websites tailored to your specific requirements. Our custom development approach ensures that every solution is perfectly aligned with your business goals, brand identity, and user needs.
                    </p>
                    <ul className="list-reset text-sm">
                      <li className="mb-8">✓ Fully responsive and mobile-optimized</li>
                      <li className="mb-8">✓ Custom design aligned with brand identity</li>
                      <li className="mb-8">✓ SEO-optimized for better visibility</li>
                      <li className="mb-8">✓ Fast loading times and optimal performance</li>
                      <li className="mb-8">✓ Easy content management and updates</li>
                    </ul>
                  </div>
                  <Image
                    className="has-shadow"
                    src="/webdevelopment.png"
                    alt="Custom Development - Web Development"
                    width={896}
                    height={504} />
                </div>
              </TabPanel>
              <TabPanel id="tab-b">
                <div className="features-tabs-panel-content">
                  <div className="features-tabs-panel-text mb-32">
                    <h3 className="mt-0 mb-16">System Integration</h3>
                    <p className="mb-16">
                      Seamlessly connect your existing systems and applications with our integration services. We ensure all your tools work together harmoniously, improving efficiency and data flow across your organization.
                    </p>
                    <ul className="list-reset text-sm">
                      <li className="mb-8">✓ API development and integration</li>
                      <li className="mb-8">✓ Third-party service connections</li>
                      <li className="mb-8">✓ Data synchronization solutions</li>
                      <li className="mb-8">✓ Legacy system modernization</li>
                    </ul>
                  </div>
                  <Image
                    className="has-shadow"
                    src="/systemintegration.png"
                    alt="System Integration"
                    width={896}
                    height={504} />
                </div>
              </TabPanel>
              <TabPanel id="tab-c">
                <div className="features-tabs-panel-content">
                  <div className="features-tabs-panel-text mb-32">
                    <h3 className="mt-0 mb-16">Data Analytics</h3>
                    <p className="mb-16">
                      Transform your raw data into actionable insights with our advanced analytics solutions. Make informed decisions based on real-time data visualization and comprehensive reporting.
                    </p>
                    <ul className="list-reset text-sm">
                      <li className="mb-8">✓ Real-time dashboards and reporting</li>
                      <li className="mb-8">✓ Data visualization tools</li>
                      <li className="mb-8">✓ Predictive analytics and forecasting</li>
                      <li className="mb-8">✓ Custom metric tracking</li>
                    </ul>
                  </div>
                  <Image
                    className="has-shadow"
                    src="/dataanalytics.png"
                    alt="Data Analytics"
                    width={896}
                    height={504} />
                </div>
              </TabPanel>
              <TabPanel id="tab-d">
                <div className="features-tabs-panel-content">
                  <div className="features-tabs-panel-text mb-32">
                    <h3 className="mt-0 mb-16">Cloud Services with Microsoft Azure</h3>
                    <p className="mb-16">
                      We leverage Microsoft Azure to power our products and deliver comprehensive cloud transformation services. Our expertise in Azure enables us to help businesses migrate to the cloud, optimize their infrastructure, and transform their operations for the digital age.
                    </p>
                    <p className="mb-16">
                      Whether you're looking to modernize legacy systems, scale your infrastructure, or build new cloud-native applications, our Azure-based solutions provide the reliability, security, and scalability your business needs.
                    </p>
                    <ul className="list-reset text-sm">
                      <li className="mb-8">✓ Azure-powered product hosting and services</li>
                      <li className="mb-8">✓ Complete cloud transformation consulting</li>
                      <li className="mb-8">✓ Legacy system migration to Azure</li>
                      <li className="mb-8">✓ Scalable Azure architecture design</li>
                      <li className="mb-8">✓ Azure infrastructure optimization</li>
                      <li className="mb-8">✓ 24/7 Azure monitoring and support</li>
                    </ul>
                  </div>
                  <Image
                    className="has-shadow"
                    src="/cloudservices.png"
                    alt="Cloud Services - Microsoft Azure"
                    width={896}
                    height={504} />
                </div>
              </TabPanel>              
            </Tabs>
          </div>
        </div>
      </section>
    );
  }
}

FeaturesTabs.propTypes = propTypes;
FeaturesTabs.defaultProps = defaultProps;

export default FeaturesTabs;